import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { tabFlagMap } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'

export const checkTabEnabled = (tabId: string, formData: TEltFormData): boolean => {
  const flagKey = tabFlagMap[tabId]
  if (!flagKey) {
    return false
  }

  return Boolean(formData[flagKey])
}
